export const userRoles = ['Admin', 'Admin', 'Customer'];

export const interventionType = ['Requested', 'Awaiting review', 'Request approved', 'Request rejected'];